import { CustomNode } from '../../../types';
import { delayIcon } from '../../../icons';

export const delayNodeConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: delayIcon,
    };
  },
};
